export default __webpack_public_path__ + "static/media/metajaytee.07b470b1.png";